import { state } from '../core/state.mjs';
import { CONFIG } from '../core/config.mjs';

/**
 * Mesure largeur conteneur avec cache temporaire
  * Cette largeur sera utilisée par imageTransform() pour dimensionner les images
 */
export function getCachedContainerWidth(element) {
    const now = Date.now();

    if (now > state.cacheValidUntil) {
        state.measurementCache.clear();
        state.cacheValidUntil = now + state.cacheDuration;
    }

    if (state.measurementCache.has(element)) {
        return state.measurementCache.get(element);
    }

    const width = element.offsetWidth || 800; // SOURCE de la taille finale des images
    state.measurementCache.set(element, width);

    if (CONFIG.debug && width === 800) {
        console.warn('[AI] Largeur par défaut 800px utilisée');
    }

    return width;
}

/**
 * Invalide cache mesures DOM
 */
export function invalidateMeasurementCache() {
    state.measurementCache.clear();
    state.cacheValidUntil = 0;
}
